import { render, staticRenderFns } from "./xieYiGuanLiDetail.vue?vue&type=template&id=ae042ed8&scoped=true&"
import script from "./xieYiGuanLiDetail.vue?vue&type=script&lang=js&"
export * from "./xieYiGuanLiDetail.vue?vue&type=script&lang=js&"
import style0 from "./xieYiGuanLiDetail.vue?vue&type=style&index=0&id=ae042ed8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae042ed8",
  null
  
)

export default component.exports